import { __require as requireClassof } from './node_modules-core-js-internals-classof.js';

var toString;
var hasRequiredToString;

function requireToString () {
	if (hasRequiredToString) return toString;
	hasRequiredToString = 1;
	var classof = requireClassof();

	var $String = String;

	toString = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String(argument);
	};
	return toString;
}

export { requireToString as __require };
//# sourceMappingURL=node_modules-core-js-internals-to-string.js.map
